// 用户认证企业窗口弹出事件
export const USER_AUTH_COMPANY_MODAL = "USER_AUTH_COMPANY_MODAL";

// 用户认证企业窗口弹出事件 认证提交
export const USER_AUTH_COMPANY_MODAL_COMFIRM = "USER_AUTH_COMPANY_MODAL_COMFIRM";